import { Stack } from '@/components/layout';
import { Button, Text, TextInput } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { AuthView } from '@/features/auth/components';
import { useForgotPassword } from '@/features/auth/hooks/use-forgot-password';
import { createStyles, useScaling } from '@/hooks';
import { colors } from '@/theme/colors';
import { Activity } from 'react';

export function ForgotPasswordScreen() {
  const { scale, isTablet } = useScaling();
  const styles = useStyles();
  const { email, onChangeEmail, onBlurEmail, handleSendResetEmail, handleCancel } =
    useForgotPassword();

  return (
    <AuthView>
      <AuthView.Content>
        <Stack
          width="100%"
          paddingX={scale({ phone: 16, tablet: 40 })}
          paddingTop={scale({ phone: 36, tablet: 30 })}
          gap={scale(10)}>
          <Text
            variant={
              isTablet
                ? 'Font Inter/Body/Bold 16px'
                : 'Font Montserrat/Subtitle/Subtitle 2 Bold 12px'
            }
            style={styles.title}
            transform="uppercase">
            {STRINGS.auth.forgotPassword.title}
          </Text>
          <Text
            variant={
              isTablet ? 'Font Inter/Subtitle/Regular 14px' : 'Font Inter/Subtitle/Regular 11px'
            }
            style={styles.description}>
            {STRINGS.auth.forgotPassword.description}
          </Text>
        </Stack>

        <Stack
          width="100%"
          paddingX={scale({ phone: 16, tablet: 40 })}
          paddingTop={scale({
            phone: 24,
            tablet: 60,
          })}
          gap={scale(24)}
          align="center">
          <TextInput value={email} onChangeText={onChangeEmail} status="default">
            <TextInput.Content>
              <TextInput.Icon
                size={scale({ phone: 16, tablet: 20 })}
                name="IcLock"
                position="left"
              />
              <TextInput.Field
                placeholder={STRINGS.auth.forgotPassword.placeholderEmail}
                keyboardType="email-address"
                autoCapitalize="none"
                autoComplete="email"
                textContentType="emailAddress"
                maxLength={100}
                autoCorrect={false}
                placeholderTextColor={colors['Labels/Tertiary']}
                onBlur={onBlurEmail}
              />
            </TextInput.Content>
          </TextInput>

          <Stack gap={scale(16)} align="center">
            <Button onPress={handleSendResetEmail} style={styles.button}>
              <Button.Text>{STRINGS.auth.forgotPassword.buttonSendResetEmail}</Button.Text>
            </Button>

            <Button variant="outline" onPress={handleCancel} style={styles.button}>
              <Button.Text transform="uppercase">
                {STRINGS.auth.forgotPassword.buttonCancel}
              </Button.Text>
            </Button>
          </Stack>
        </Stack>

        <Stack flex={1} />

        <Stack align="center" gap={scale(4)}>
          <Activity mode={isTablet ? 'hidden' : 'visible'}>
            <AuthView.Hint />
          </Activity>
          <AuthView.Logo />
        </Stack>
      </AuthView.Content>
    </AuthView>
  );
}

const useStyles = createStyles(({ scale }) => ({
  title: {
    color: colors.Blue,
  },
  description: {
    color: colors['6'],
  },
  button: {
    width: scale({
      phone: 212,
      tablet: 240,
    }),
  },
}));
